import HelpIcon from "@mui/icons-material/Help";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React from "react";
import { styled } from '@mui/material/styles';
import {Typography} from "@material-ui/core";


const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    width:"auto",
    fontSize:14,
    textAlign:"justify",
    backgroundColor:"#5E91B6",
    padding:10,
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    "a, a:visited": {
      color: "#FFE3B0",
      fontWeight: 600,
      textDecoration: "underline",
      textUnderlineOffset: "3px",
    },
    "a:hover": { color: "#FFF0D5" },
    "a:focus-visible": { outline: "2px solid #FFE3B0", outlineOffset: "3px" },
  },
});

export const ToolTipPerso = (props) => {

    return (
        <CustomWidthTooltip
        title={
            typeof props.title === "string" && props.title.includes("\n") ?
                <Typography style={{ fontSize: 14 }}>
                    {props.title.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                            {index > 0 && <br />}
                            {line}
                        </React.Fragment>
                    ))}
                </Typography>
            : props.title
        }
        placement="right"
        >
            <HelpIcon style={{fill: "#5E91B6", marginLeft: 4, marginBottom: -3, width: 18, height: 18}}/>
        </CustomWidthTooltip>
    )
}